import { DateTime } from "luxon";
import { RRule } from "rrule";
import { EventCreationState, EventTemplateData } from "./sesh_types";
import { time_format_utils } from "./time_format_utils";

export function eventCreationStateToTemplateData(
	state: EventCreationState
): EventTemplateData {
	// TODO: would be very nice to just use { ...state } here, but state has some bad things we don't want
	return {
		allow_maintain_repeat_rsvp: state.allow_maintain_repeat_rsvp ?? false,
		event_timezone: state.event_timezone,
		attendee_role_data: state.attendee_role_data,
		color: state.color,
		description: state.description,
		duration_ms: state.duration_ms,
		event_name: state.event_name,
		eligible_role_ids: state.eligible_role_ids,
		exdates: state.exdates,
		hide_attendees: state.hide_attendees,
		image_url: state.image_url,
		native_event_data: state.native_event_data,
		rdates: state.rdates,
		role_mentions_on_create: state.role_mentions_on_create,
		rsvp_options: state.rsvp_options,
		server_reminders: state.server_reminders,
		thread_settings: state.thread_settings,
		user_mentions_on_create: state.user_mentions_on_create,
		start_time: state.start_time
			? new Date(state.start_time as unknown as string)
			: undefined,
		sent_channel_data: state.selected_channel,
		rrule_str: state.rrule
			? RRule.optionsToString(
					time_format_utils.transformRRuleToTimezone(
						state.rrule.origOptions,
						// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
						state.user_timezone!,
						state.start_time ?? DateTime.now()
					)
			  )
			: undefined,
		rsvp_lock_before_ms: state.rsvp_lock_before_ms,
	};
}
